import axios from "axios";

const API_BASE_URL =
  (process.env.NODE_ENV === "development" && "http://localhost:8000") || "";

export const createRazorpayOrder = async (amount) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/v1/payment/process`,
    { amount },
    { withCredentials: true }
  );
  return data;
};

export const getRazorpayKey = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/v1/getKey`, {
    withCredentials: true,
  });
  return data.key;
};
